<template>
	<div>
		<iframe :src="url" scrolling="no" frameborder="0" width="300px" height="410px"></iframe>
	</div>
</template>

<script>
import {
	mapGetters,
	mapActions
} from 'vuex'

export default {
	name: 'accountEditWx',
	data () {
		return {
			url: '',
			openId: '',
		}
	},
	methods: {
		...mapActions('user', ['getQrAuthorize', 'getUpdateQrOpenid']),
		getQr: function () {
			this.getQrAuthorize().then(data => {
				if (data.data.isSuccess) {
					this.url = data.data.data
				} else {
					this.$message({
						message: data.data.message,
						type: 'error'
					})
				}
			})
		}
	},
	created () {
		this.getQr()
		var This = this
		window.loginCode = function (id, name, img) {
			if (id) {
				let params = {
					username: This.userInfo.username,
					openid: id,
					nickname: encodeURI(name),
					headImgUrl: img,
				}
				This.getUpdateQrOpenid(params).then(res => {
					if (res.data.isSuccess) {
						//绑定成功改变登录框状态
						window.localStorage.loginStatus = false
						This.$message({
							message: res.data.message,
							type: 'success'
						})
						This.$emit('Close')
					} else {
						This.$message({
							message: res.data.message,
							type: 'error'
						})
					}
				})
			} else {
				this.$message({
					message: '获取openId失败，请稍后再试',
					type: 'error'
				})
			}
		}
	},
	components: {

	},
	computed: {
		...mapGetters('user', ['userInfo'])
	},
}

</script>


<style lang="scss" scoped>
iframe {
	display: block;
	margin: 30px auto 0;
}
</style>
